import {
    AppstoreAddOutlined,
    AntDesignOutlined,
    BarcodeOutlined,
    BgColorsOutlined,
    FontSizeOutlined,
    DatabaseOutlined,
    FileTextOutlined,
    LoadingOutlined,
    UserOutlined,
    DollarOutlined,
    FormOutlined,
    SendOutlined,
    FileDoneOutlined,
    ClockCircleOutlined,
    ExceptionOutlined,
    NumberOutlined,
  } from "@ant-design/icons";
import { Typography } from "@mui/material";
  
  const icons = {
    FontSizeOutlined,
    BgColorsOutlined,
    BarcodeOutlined,
    AntDesignOutlined,
    LoadingOutlined,
    DatabaseOutlined,
    FileTextOutlined,
    AppstoreAddOutlined,
    UserOutlined,
    DollarOutlined,
    FormOutlined,
    SendOutlined,
    FileDoneOutlined,
    ClockCircleOutlined,
    ExceptionOutlined,
    NumberOutlined,
  };
  
  const reports = {
    id: "utilities",
    title: (
      <Typography variant="h5" component="div">
        General Reports
      </Typography>
    ),
    type: "accordion",
    children: [
    {
       id: "trade",
       title: "Trade History",
       type: "item",
       url: "/trade-view",
       icon: icons.ClockCircleOutlined,
    },
    {
      id: "warehouseInventory",
      title: "Warehouse Inventory",
      type: "item",
      url: "/warehouse-inventory-view",
      icon: icons.DatabaseOutlined,
    },
    {
      id: "inventory",
      title: "Inventory",
      type: "item",
      url: "/inventory-view",
      icon: icons.DatabaseOutlined,
    },
    {
      id: "claims-report",
      title: "Claims Report",
      type: "item",
      url: "/claims-report-view",
      icon: icons.ExceptionOutlined,
    },
    {
      id: "nicotine-sugar-report",
      title: "Nicotine-Sugar Report",
      type: "item",
      url: "/nicotine-sugar-report-view",
      icon: icons.NumberOutlined,
    },
    {
      id: "fx-rate-report",
      title: "FX Rate History",
      type: "item",
      url: "/fx-rate-report-view",
      icon: icons.DollarOutlined,
    },
    {
      // PO / SO cross-reference report showing SR and SI coverage
      id: "shipment-status-report",
      title: "Shipment Status Report",
      type: "item",
      url: "/shipment-status-report-view",
      icon: icons.SendOutlined,
    },
    {
      id: "stakeholder-report",
      title: "Staeholder Report",
      type: "item",
      url: "/stakeholder-report-view",
      icon: icons.SendOutlined,
    },
    ],
  };
  
  export default reports;
  